export interface SelectDto {
  value: string;
  label: string;
}

export const SizeList: SelectDto[] = [
  { value: '10', label: '10개씩 보기' },
  { value: '20', label: '20개씩 보기' },
  { value: '30', label: '30개씩 보기' },
  { value: '40', label: '40개씩 보기' },
  { value: '50', label: '50개씩 보기' },
];

export const HistoryTypeList: SelectDto[] = [
  { value: 'ALL', label: '전체' },
  { value: 'ENTRY', label: '입차' },
  { value: 'EXIT', label: '출차' },
  { value: 'POUR', label: '타설' },
];
